/**
 * Point d'entrée unique du tunnel d'achat (panier + livraison + paiement).
 * Évite l'ancienne page intermédiaire « Mon panier » sous /mon-compte/panier.
 */
export const CHECKOUT_FLOW_ENTRY = "/valider-commande";

/**
 * Routes où la navbar doit utiliser le thème « checkout » (fond blanc, liens foncés, logo bicolore).
 */
export function isCheckoutFlowNavbarTheme(pathname: string): boolean {
  if (pathname === CHECKOUT_FLOW_ENTRY) return true;
  if (pathname === "/panier") return true;
  if (pathname === "/achats") return true;
  if (pathname.startsWith("/produit/")) return true;
  if (pathname === "/commande-details") return true;
  if (pathname === "/paiement") return true;
  return false;
}
